import { ImageAttributesHelperService } from '@alliance/clubs/utils'
import { ChangeDetectionStrategy, Component } from '@angular/core'
import { BaseCardComponent } from '../base/card.component'

@Component({
  selector: 'alliance-clubs-posts-card-mobile',
  templateUrl: './card-mobile.component.html',
  styleUrls: ['../base/card.component.tw.css', './card-mobile.component.tw.css'],
  providers: [ImageAttributesHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardMobileComponent extends BaseCardComponent {
  public state = this.connectViewState(['post', 'withImg', 'withRubrics', 'titleClasses', 'imageAttributes'])
}
